import { useTranslation } from "react-i18next";
import {
    formatNumber,
    formatPercent,
    formatVolume,
} from "~/utils/number-format";
import clsx from "clsx";
import { getBuySellColor, getTextSize } from "../utils";
import { DURATION_TYPES } from "../constants";
import { Skeleton } from "antd-mobile";

export default function KDetailTokenChange({
    tokenChangeData,
    className = "",
    isSolana = false,
}: any) {
    const { t } = useTranslation();

    const { txn, vol } = tokenChangeData;

    const ItemDesc = ({ value, change, showSymbol = false }: any) => {
        return (
            <div className="font-Semibold whitespace-nowrap flex-1">
                <div className="text-body3 text-text_1">
                    {showSymbol ? formatVolume(value) : formatNumber(value)}
                </div>
                <div
                    className={clsx("", getBuySellColor(change))}
                    style={{
                        ...getTextSize(
                            formatPercent(change).length,
                            10,
                            13,
                            12
                        ),
                    }}
                >
                    {formatPercent(change)}
                </div>
            </div>
        );
    };

    return (
        <div className={clsx("w-full px-[16px]", className)}>
            <div className="border-[0.5px] border-border_2 rounded-[12px] px-[12px]">
                <div className="flex justify-between py-1.5 border-b-[0.5px] border-border_2">
                    <div className="w-[68px] flex-none" />

                    {txn.length > 0
                        ? txn.map((item: any, index: any) => {
                              const title = DURATION_TYPES.find(
                                  (type) => type.id === item.duration
                              );

                              return (
                                  <div key={index} className="flex-1">
                                      <span className="text-direction2 font-Regular text-text_2">
                                          {title?.key}
                                      </span>
                                  </div>
                              );
                          })
                        : [1, 2, 3].map((item) => {
                              return (
                                  <div key={item} className="flex-1">
                                      <Skeleton
                                          animated
                                          className={
                                              "w-[14px] h-[14px] rounded-[2px]"
                                          }
                                      />
                                  </div>
                              );
                          })}
                </div>
                {!isSolana && (
                    <div className="flex justify-between py-3 border-b-[0.5px] border-border_2">
                        <div className="w-[68px] flex-none">
                            <span className="font-Semibold text-body3">
                                {t("txns")}
                            </span>
                        </div>

                        {txn.length > 0
                            ? txn.map((item: any, index: any) => {
                                  const title = DURATION_TYPES.find(
                                      (type) => type.id === item.duration
                                  );
                                  return (
                                      <ItemDesc
                                          key={index}
                                          value={item.value}
                                          change={item.change}
                                          title={title?.key}
                                      />
                                  );
                              })
                            : [1, 2, 3].map((item) => {
                                  return (
                                      <div
                                          key={item}
                                          className="flex-1 flex flex-col gap-[3px]"
                                      >
                                          <Skeleton
                                              animated
                                              className={
                                                  "w-[36px] h-[18px] rounded-[2px]"
                                              }
                                          />
                                          <Skeleton
                                              animated
                                              className={
                                                  "w-[12px] h-[12px] rounded-[2px]"
                                              }
                                          />
                                      </div>
                                  );
                              })}
                    </div>
                )}
                <div className="flex justify-between py-3">
                    <div className="w-[68px] flex-none">
                        <span className="font-Semibold text-body3">
                            {t("volume")}
                        </span>
                    </div>
                    {vol.length > 0
                        ? vol.map((item: any, index: number) => (
                              <ItemDesc
                                  key={index}
                                  value={item.value}
                                  change={item.change}
                                  showSymbol={true}
                              />
                          ))
                        : [1, 2, 3].map((item) => {
                              return (
                                  <div
                                      key={item}
                                      className="flex-1 flex flex-col gap-[3px]"
                                  >
                                      <Skeleton
                                          animated
                                          className={
                                              "w-[36px] h-[18px] rounded-[2px]"
                                          }
                                      />
                                      <Skeleton
                                          animated
                                          className={
                                              "w-[12px] h-[12px] rounded-[2px]"
                                          }
                                      />
                                  </div>
                              );
                          })}
                </div>
            </div>
        </div>
    );
}
